export default __webpack_public_path__ + "media/images/landing-17-550x420-4db04f1637835a0a244c70a1046c16d5.jpg";